/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm';
import throttle from 'lodash/throttle';

[...document.querySelectorAll('header')].forEach(el => {
  new Vue({
    el,
    data() {
      return {
        isSticky: false,
        scrollPosition: 0,
        scrollDirection: null,
        isSearchBarOpen: false,
        currentUrl: '',
      };
    },
    computed: {
      inviqaHeaderClasses() {
        return {
          'inviqa-header--sticky': this.isSticky,
          'inviqa-header--search-bar-visible': this.isSearchBarOpen,
        };
      },
      isDesktop() {
        return window.innerWidth >= 1200;
      },
      logoOffset() {
        return this.isDesktop ? 20 : 10;
      },
    },
    methods: {
      logoHasReachedTop(scrollPosition) {
        return scrollPosition > this.logoOffset;
      },
      makeHeaderSticky() {
        this.isSticky = true;
        document.querySelector('main').classList.add('header-is-sticky');
        document.querySelector('header').classList.add('inviqa-header--sticky');
      },
      unmakeHeaderSticky() {
        this.isSticky = false;
        document.querySelector('main').classList.remove('header-is-sticky');
        document.querySelector('header').classList.remove('inviqa-header--sticky');
      },
      handleScroll() {
        this.checkHeaderPosition();
        this.detectScrollDirection();
      },
      detectScrollDirection() {
        throttle(() => {
          this.scrollDirection = document.body.getBoundingClientRect().top > this.scrollPosition ? 'up' : 'down';
          this.scrollPosition = document.body.getBoundingClientRect().top;
          if (this.scrollDirection === 'up') {
            document.querySelector('header').classList.add('not-engaged');
          } else {
            document.querySelector('header').classList.remove('not-engaged');
          }
        }, 300)();
      },
      checkHeaderPosition() {
        throttle(() => {
          const scrollPosition = Math.round(window.scrollY);
          if (this.logoHasReachedTop(scrollPosition)) {
            this.makeHeaderSticky();
          } else {
            this.unmakeHeaderSticky();
          }
        }, 300)();
      },
      toggleSearchBar() {
        if (this.currentUrl !== '/search') {
          this.isSearchBarOpen = !this.isSearchBarOpen;
        }

        if (this.isSearchBarOpen) {
          setTimeout(() => {
            document.querySelector('.search-bar .form-item-search-api-fulltext .form-text').focus();
          }, 0);
        }
      },
      closeSearchBar() {
        if (this.isSearchBarOpen) {
          this.isSearchBarOpen = false;
        }
      },
    },
    mounted() {
      const vm = this;
      window.addEventListener('scroll', this.handleScroll);
      // eslint-disable-next-line func-names
      document.addEventListener('click', function(event) {
        // eslint-disable-next-line prettier/prettier
        if (!event.target.closest('.search-bar') && (vm.currentUrl !== '/search')) {
          vm.closeSearchBar();
        }
      });
      // eslint-disable-next-line func-names
      document.querySelector('.inviqa-header .search-toggle').addEventListener('click', function(event) {
        event.stopPropagation();
      });
      this.checkHeaderPosition();
    },
    created() {
      this.currentUrl = window.location.pathname;
      if (this.currentUrl === '/search') {
        this.isSearchBarOpen = true;

        if (this.isSearchBarOpen) {
          setTimeout(() => {
            document.querySelector('.search-bar .form-item-search-api-fulltext .form-text').focus();
          }, 0);
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  });
});
